<div id="downloadModal">
  <div class="" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="downloadModalLabel">Novedades en NUVALID!</h5>
      </div>
      <div class="modal-body" style="display: flex;">
        <div>
          <!-- Estamos emocionados de anunciar que hemos añadido dos importantes funciones en NUVALID: -->
          <p class="form-info__text">
            Estamos emocionados de anunciar que hemos añadido una función importante en NUVALID:
          </p>
          <p><strong>Prescripción de Estudios:</strong> Ahora puedes prescribir estudios para OSDE directamente desde la
            aplicación.</p>

          <ng-container *ngIf="isElectron">
            <p>
              <strong>¡Nuvalid ahora también en la web!</strong> Nos alegra contarte que ya podés acceder a Nuvalid
              directamente desde tu navegador, sin necesidad de descargar ni instalar nada. Ingresá fácilmente desde
              cualquier dispositivo a través de:
              <a href="https://nuvalid.app" target="_blank" class="reminder__link">
                nuvalid.app
              </a>
            </p>
          </ng-container>

          <!-- <p><strong>Rescate de Estudios:</strong> Accede y rescata estudios realizados para OSDE de manera fácil y
            rápida.</p> -->
          <!-- <p class="form-info__text">
            Para utilizar estas nuevas funciones, simplemente dirígete a Operaciones y agrégalas.
          </p>
          <p class="form-info__text">
            Estas mejoras están diseñadas para optimizar tu experiencia y agilizar los procesos. ¡Explora estas nuevas
            funciones hoy mismo!
          </p> -->
        </div>
      </div>
      <div class="modal-footer">
        <button class="buttonNoVolverAMostrar" (click)="noVolverAMostrar()">No volver a mostrar</button>
        <button class="buttonAnularTicket" (click)="devolverRespuesta('CERRAR')">Cerrar</button>
      </div>
    </div>
  </div>
</div>
